import React from "react";
import { SECTIONS } from "../../../../../config/config";
import AppStartMessage from "./AppStartMessage";
import EndSectionMessageOK from "./EndSectionMessageOK";
import PleaseWait from "./PleaseWait";
import WelcomeBackMessage from "./WelcomeBackMessage";
import WelcomeBackMessageWithProgress from "./WelcomeBackMessageWithProgress";
import { assetIds } from "nemuru-components";
import { VideoIdWelcomeMessage } from "./VideoIdWelcomeMessage";

export const FLOW_MESSAGES = {
  SECTION_LOAN_CONDITIONS_END: {
    id: "SECTION_LOAN_CONDITIONS_END",
    messageDuration: 2500,
    component: (hidingMessage) => (
      <EndSectionMessageOK
        iconName={SECTIONS.LOAN_CONDITIONS.titleIconName}
        textId={SECTIONS.LOAN_CONDITIONS.endOKMessageTextId}
        hidingMessage={hidingMessage}
      />
    ),
  },
  SECTION_IDENTIFICATION_END: {
    id: "SECTION_IDENTIFICATION_END",
    messageDuration: 2500,
    component: (hidingMessage) => (
      <EndSectionMessageOK
        iconName={SECTIONS.IDENTIFICATION.titleIconName}
        textId={SECTIONS.IDENTIFICATION.endOKMessageTextId}
        hidingMessage={hidingMessage}
      />
    ),
  },
  SECTION_FINANCES_END: {
    id: "SECTION_FINANCES_END",
    messageDuration: 2500,
    component: (hidingMessage) => (
      <EndSectionMessageOK
        iconName={SECTIONS.FINANCES.titleIconName}
        textId={SECTIONS.FINANCES.endOKMessageTextId}
        hidingMessage={hidingMessage}
      />
    ),
  },
  CO_BORROWER_ADDED: {
    id: "CO_BORROWER_ADDED",
    messageDuration: 2500,
    component: (hidingMessage) => (
      <EndSectionMessageOK
        iconName={SECTIONS.IDENTIFICATION.titleIconName}
        textId={"CO_BORROWER_GUARANTOR_ADDED_CORRECTLY"}
        hidingMessage={hidingMessage}
      />
    ),
  },
  WELCOME_BACK: {
    id: "WELCOME_BACK",
    messageDuration: null,
    component: (hidingMessage, onHideMessage) => (
      <WelcomeBackMessage
        hidingMessage={hidingMessage}
        showStartButton
        onHideMessage={onHideMessage}
      />
    ),
  },
  WELCOME_BACK_WITH_PROGRESS: {
    id: "WELCOME_BACK_WITH_PROGRESS",
    messageDuration: null,
    component: (hidingMessage, onHideMessage) => (
      <WelcomeBackMessageWithProgress
        hidingMessage={hidingMessage}
        showStartButton
        onHideMessage={onHideMessage}
      />
    ),
  },
  SEND_OK: {
    id: "SEND_OK",
    messageDuration: 1400,
    component: (hidingMessage) => (
      <EndSectionMessageOK hidingMessage={hidingMessage} />
    ),
  },
  APP_START: {
    id: "APP_START",
    messageDuration: 1800,
    component: (hidingMessage) => (
      <AppStartMessage textId={" "} hidingMessage={hidingMessage} />
    ),
  },
  PLEASE_WAIT: {
    id: "PLEASE_WAIT",
    messageDuration: 1500,
    component: (hidingMessage, onHideMessage) => (
      <PleaseWait hidingMessage={hidingMessage} onHideMessage={onHideMessage} />
    ),
  },
  DOCUMENTATION_UPLOADED: {
    id: "DOCUMENTATION_UPLOADED",
    messageDuration: 2500,
    component: (hidingMessage) => (
      <EndSectionMessageOK
        iconName={assetIds.ICON_CLOUD_UPLOAD}
        textId={"DOCUMENTATION_UPLOADED_SUBTITLE"}
        hidingMessage={hidingMessage}
      />
    ),
  },
  VIDEO_ID_WELCOME_MESSAGE: {
    id: "VIDEO_ID_WELCOME_MESSAGE",
    messageDuration: null,
    component: (hidingMessage, onHideMessage) => (
      <VideoIdWelcomeMessage
        showStartButton
        hidingMessage={hidingMessage}
        onHideMessage={onHideMessage}
      />
    ),
  },
};
